<script context="module">
  export const calculateResultingHeadingLevel = (
    suggestedHeadingLevel,
    currentDynamicHeadingLevel
  ) => {
    const levelSum = suggestedHeadingLevel - 1 + currentDynamicHeadingLevel;

    //  Subtract 1 from suggestedHeadingLevel to get the level of the DynamicHeadingContext
    return levelSum > Constants.MaximumHeadingLevel
      ? Constants.MaximumHeadingLevel
      : levelSum < 1
        ? 1
        : levelSum;
  };
</script>

<script>
  import { getContext } from "svelte";
  import { Constants } from "./DynamicHeadingContext.svelte";

  // @ts-check
  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** For parts of the website where heading levels have to be explicitly set because they are siblings
  of other headings.
  Example: An Rich text Article that has both an h1, and two h2, like a blog article
  <DynamicHeading suggestedHeadingLevel="1">Cake Recipe</DynamicHeading>
  <DynamicHeading suggestedHeadingLevel="2">Ingredients</DynamicHeading>
  <DynamicHeading suggestedHeadingLevel="2">Preparation</DynamicHeading>

  If the current DynamicHeadingContext is 2, the resulting heading levels will be h2, h3 and h3
   * @type {1 | 2 | 3 | 4 |5 |6} */
  export let suggestedHeadingLevel = 1;

  // TODO make this a const after DynamicLevelContext has been added to the obama-swa.
  let currentDynamicHeadingLevel = getContext(Constants.DynamicHeadingContext);
  if (!currentDynamicHeadingLevel) {
    // TODO: Since we are using SvelteKit throwing an error will abort a new build with Headings that we are not be acknowledging for, and it will also be stopped in the CI, so we can fix it before deploying.
    // But right now it will break the tests and will need a significant effort to make it work
    console.error("DynamicHeading must be used inside of a DynamicHeadingContext");
  }

  const resultingHeadingLevel = calculateResultingHeadingLevel(
    suggestedHeadingLevel,
    currentDynamicHeadingLevel
  );

  let className = undefined;
  export { className as class };

  /** @type {HTMLElement} | undefined} */
  export let ref = undefined;

  const currentElement = `h${resultingHeadingLevel}`;
</script>

<!--
@component
This component renders the heading level based on the context of the DynamicHeadingContext, unless the prop for suggestedHeadingLevel is set, in that case
it will render the heading level based on the suggestedHeadingLevel prop plus the context minus 1, since headings start at 1 and not 0.


```svelte
<DynamicHeadingContext>
  <DynamicHeading>This is an h1</DynamicHeading>
  <DynamicHeadingContext>
    <DynamicHeading>This is an h2</DynamicHeading>
    <DynamicHeading suggestedHeadingLevel="3">This is an h4</DynamicHeading>
    <DynamicHeadingContext>
      <DynamicHeading>This is an h3</DynamicHeading>
      <DynamicHeading suggestedHeadingLevel="1">This is an h3</DynamicHeading>
    </DynamicHeadingContext>
  </DynamicHeadingContext>
</DynamicHeadingContext>
-->
<svelte:element
  this={currentElement}
  {...$$props}
  {...$$restProps}
  {id}
  class={className}
  bind:this={ref}
>
  <slot />
</svelte:element>
